// Default parameters per operation - Hungarian labels handled separately
export const OPERATIONS = [
  { id: 'pocket', name: 'Zsebmarás', desc: 'Négyzet vagy kör alakú zseb', icon: 'Square' },
  { id: 'contour', name: 'Kontúrm.', desc: 'Zárt/nyitott kontúr marása', icon: 'PenTool' },
  { id: 'drilling', name: 'Furatok', desc: 'Furat ciklusok (peck/simple)', icon: 'CircleDot' },
  { id: 'facing', name: 'Homlokm.', desc: 'Sík felület megmunkálása', icon: 'Layers' },
  { id: 'engraving', name: 'Gravírozás', desc: 'Vonalvezetés V-maróval', icon: 'Feather' },
  { id: 'thread', name: 'Menetm.', desc: 'Helikális menetmarás', icon: 'Waves' },
  { id: 'arc', name: 'Ívmarás', desc: 'Körív/horony', icon: 'Circle' },
  { id: 'grid', name: 'Rács furatok', desc: 'Furat mátrix elrendezés', icon: 'Grid3x3' },
];

const basePost = () => ({
  units: 'mm', wcs: 'G54', decimals: 4, use_line_numbers: false,
  coolant: true, safe_z: 25, retract_z: 25, program_name: 'PROGRAM',
});

export const DEFAULT_PARAMS = {
  pocket: {
    shape: 'rect', width: 50, height: 30, diameter: 40, depth: 5, step_down: 1.5,
    tool_diameter: 6, stepover_pct: 45, feed_xy: 600, feed_z: 150, rpm: 12000,
    tool_num: 1, origin_x: 0, origin_y: 0, post: basePost(),
  },
  contour: {
    points: [[0,0],[50,0],[50,30],[20,30],[20,15],[0,15]], closed: true,
    depth: 3, step_down: 1, tool_diameter: 6, side: 'on',
    feed_xy: 600, feed_z: 150, rpm: 12000, tool_num: 2, post: basePost(),
  },
  drilling: {
    holes: [[10,10],[30,10],[50,10],[10,30]], depth: 10, peck: 2, dwell: 0,
    style: 'peck', feed_z: 150, retract_z: 2, rpm: 3000, tool_num: 3,
    tool_diameter: 3, post: basePost(),
  },
  facing: {
    width: 100, height: 60, depth: 1, step_down: 0.5, tool_diameter: 20,
    stepover_pct: 70, feed_xy: 1200, feed_z: 200, rpm: 8000, tool_num: 4,
    origin_x: 0, origin_y: 0, post: basePost(),
  },
  engraving: {
    polylines: [[[0,0],[10,0],[10,10],[0,10],[0,0]],[[15,0],[15,10]],[[20,0],[20,10]],[[15,5],[20,5]]],
    depth: 0.3, feed_xy: 400, feed_z: 100, rpm: 18000, tool_num: 5,
    tool_diameter: 0.5, post: basePost(),
  },
  thread: {
    nominal_diameter: 10, pitch: 1.5, length: 12, tool_diameter: 4,
    thread_type: 'internal', direction: 'right', feed_xy: 300, feed_z: 100,
    rpm: 6000, tool_num: 6, center_x: 0, center_y: 0, z_top: 0, post: basePost(),
  },
  arc: {
    center_x: 0, center_y: 0, radius: 20, start_angle_deg: 0, sweep_deg: 180,
    depth: 3, step_down: 1, tool_diameter: 6, direction: 'ccw',
    feed_xy: 500, feed_z: 150, rpm: 10000, tool_num: 7, post: basePost(),
  },
  grid: {
    rows: 3, cols: 4, dx: 20, dy: 15, origin_x: 0, origin_y: 0,
    depth: 8, peck: 2, style: 'peck', feed_z: 150, rpm: 3000,
    tool_num: 3, tool_diameter: 3, post: basePost(),
  },
};
